import Scriba from 'react-scriba';

export class DataDocumentLotType {

    static _chargementDesDocumenLotType(idDocumentLotCategorie) {
        let objet = {
            "idDocumentLotCategorie": idDocumentLotCategorie
        };

        var url = "api/Liste/ListeDesDocumentLotType";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}